export const disableScroll = () => {
  document.body.style.overflowX = 'hidden';
  document.body.style.overflowY = 'hidden';
};

export const enableScroll = () => {
  document.body.style.overflowX = 'scroll';
  document.body.style.overflowY = 'scroll';
};
